import $ from "jquery";
import ko from "knockout";
import md from "util/markdownRenderer";

ko.bindingHandlers["markdown"] = {
    update: function (element, valueAccessor) {
        const value = ko.unwrap(valueAccessor());
        $(element).html(md.render(value));
    },
} as ko.BindingHandler<ko.Observable<string>>;
